import { ColumnDef } from '@tanstack/react-table'
import { GetCommissionCashbackResponseData } from '@/modules/promotion/type'
import { Pencil } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Button } from '@/common/ui/button'
import { DeleteCommission } from './CellAction/components/DeleteCommission'
import { IsActiveCommission } from './CellAction/components/IsActiveCommission'
import { Badge } from '@/common/ui/badge'

export const columns: ColumnDef<GetCommissionCashbackResponseData>[] = [
	{
		accessorKey: 'name',
		header: 'รายการโปรโมชั่น',
		cell: ({ row }) => <p className="font-medium">{row.original.name}</p>,
	},
	{
		accessorKey: 'startDate',
		header: 'ช่วงเวลา',
		cell: ({ row }) => (
			<div className="space-y-1 text-sm">
				<p>
					เริ่ม:{' '}
					{row.original.startDate
						? new Date(row.original.startDate).toLocaleString()
						: 'ไม่มีกำหนด'}
				</p>
				<p className="font-medium">
					สิ้นสุด:{' '}
					{row.original.endDate
						? new Date(row.original.endDate).toLocaleString()
						: 'ไม่มีกำหนด'}
				</p>
			</div>
		),
	},
	{
		accessorKey: 'isActive',
		header: 'สถานะ',
		cell: ({ row }) => (
			<Badge variant={row.original.isActive ? 'default' : 'secondary'}>
				{row.original.isActive ? 'เปิดใช้งาน' : 'ปิดใช้งาน'}
			</Badge>
		),
	},
	{
		accessorKey: 'createdAt',
		header: 'วันที่สร้าง/แก้ไข',
		cell: ({ row }) => (
			<div className="space-y-1 text-sm">
				<p>สร้าง: {new Date(row.original.createdAt).toLocaleString()}</p>
				<p className="font-medium">
					แก้ไข: {new Date(row.original.updatedAt).toLocaleString()}
				</p>
			</div>
		),
	},
	{
		id: 'actions',
		header: 'การดำเนินการ',
		cell: ({ row }) => (
			<div className="flex items-center gap-2">
				<IsActiveCommission row={row.original} />
				<Link to={`/operator/commission/${row.original.id}`}>
					<Button variant="ghost" size="icon">
						<Pencil className="h-4 w-4" />
					</Button>
				</Link>
				<DeleteCommission id={row.original.id} />
			</div>
		),
	},
]

export const writeAccessorKeys = ['actions']
